import { getPrimaryTracker, setPrimaryTracker } from 'usage-tracker-container';
import { createPublicTracker } from './createPublicTracker';
export function setupEventTracker() {
  setPrimaryTracker(createPublicTracker());

  // Required default event properties needs to be set here if we want event tracking on App level - otherwise, it will be undefined and cause usage-tracker-js event error. Properties should not include data from non-blocking fetches as it may not be available when this is called.
  getPrimaryTracker().setProperties({
    isBillingAdmin: false,
    inAppOrPublic: 'public',
    isDotComAuthedRedirect: false
  });
}
const PREVIEW_TRACKING_WARNING = '[pricing preview] This is a fake page, so no events will be sent.';
function warnSkippedTracking(method, detail) {
  // eslint-disable-next-line no-console
  console.warn(`${PREVIEW_TRACKING_WARNING} (${method})`, ...(detail === undefined ? [] : [detail]));
}

// Preview routes must not send events or start session replay, but
// getPrimaryTracker() throws when nothing is registered and components call
// it directly during render.
export function setupNoopEventTracker() {
  const noopTracker = {
    track: (...args) => {
      warnSkippedTracking('track', args);
    },
    setProperties: properties => {
      warnSkippedTracking('setProperties', properties);
    },
    clone: () => {
      warnSkippedTracking('clone');
      return noopTracker;
    },
    getConfig: () => {
      warnSkippedTracking('getConfig');
      return {
        standalone: true,
        debug: true,
        properties: {}
      };
    }
  };
  setPrimaryTracker(noopTracker);
}